import { Store, combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { reducers as sharedReducers } from '@innovyze/stylovyze';

declare global {
  interface Window {
    store: Store;
  }
}

const store = configureStore({
  reducer: combineReducers({
    ...sharedReducers,
  }),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }),
  devTools: true,
});

export default store;
export { store };
